import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import { ApolloProvider } from '@apollo/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/app/router';

import 'overlayscrollbars/overlayscrollbars.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <ApolloProvider client={mainBackendApolloClient}>
      <RouterProvider router={router} />
    </ApolloProvider>
  </StrictMode>
);
